import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserDetailLogsTable from '../screens/BackOfficeUserDetailLogsTable'
import moment from 'moment'

moment.locale('it')

const mapStateToProps = (state) => {
  return {
    state: state.users
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

class BackOfficeUserDetailVehicleLogsContainer extends Component {
  static propTypes = {
    vehicleId: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      logs: [],
      loading: false
    }

    this.fetchLogs = this.fetchLogs.bind(this)
  }

  componentDidMount () {
    this.fetchLogs()
  }

  fetchLogs () {
    this.setState({loading: true})

    SostaOnlineApiService.fetchVehicleLogs(this.props.vehicleId).then((data) => {
      this.setState({
        logs: data.data,
        loading: false
      })
    })
  }

  render () {
    const {logs} = this.state
    return (
      <div>
        {logs.map((item, index) => {
          return (
            <div>
              <strong>{moment(item.createdAt).format('L LT')}</strong>:{' '}
              {item.Operator.firstName + ' ' + item.Operator.lastName}{' '}
              <strong>{item.message}</strong> - {item.description}
              <hr style={{marginBottom: '5px', marginTop: '5px'}} />
            </div>
          )
        })}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailVehicleLogsContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserDetailVehicleLogsContainer.js